import { css } from 'styled-components'

const SingleLineCssTrim = css`
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`

export default SingleLineCssTrim
